export function getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
	if (typeof navigator === 'undefined') return 'desktop';

	const userAgent = navigator.userAgent;

	if (/tablet|ipad|playbook|silk/i.test(userAgent) || (/android/i.test(userAgent) && !/mobile/i.test(userAgent))) {
		return 'tablet';
	}

	if (/mobile|android|iphone|ipod|iemobile|blackberry|kindle/i.test(userAgent)) {
		return 'mobile';
	}

	return 'desktop';
}
